<div [hidden]="!buttontext" >
<button class="btn eod-btn-primary btn-sm" (click)="onUserAction(viewdetailaction)">
            {{ buttontext }}
</button>
</div>